<template>
	<v-menu :close-on-content-click="false" min-width="290px" offset-y transition="scale-transition" v-model="menu">
		<template #activator="{ on }">
			<v-text-field
				:class="{ 'custom-cursor': $props.readonly }"
				:error="errorBorder"
				:error-messages="error"
				:hide-details="hideDetails"
				:disabled="disabled"
				:label="dateLabel"
				v-model="valueFormatted"
				v-on="on"
				@blur="textFieldBlur()"
				@focus="textFieldFocus()"
				ref="dateField"
			></v-text-field>
		</template>
		<v-date-picker
			:first-day-of-week="1"
			:locale="'hr'"
			:max="maxDate"
			:readonly="readonly"
			@input="menu = false"
			v-model="selectedValue"
		></v-date-picker>
	</v-menu>
</template>

<script>
export default {
	name: 'DatePicker',
	props: {
		readonly: Boolean,
		value: String,
		maxDate: String,
		dateLabel: String,
		disabled: Boolean,
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			menu: false,
			valueFormatted: null,
			selectedValue: this.$props.value,
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal != null) {
					if (this.selectedValue != null) {
						if (this.selectedValue.value != newVal) {
							this.setValue(newVal);
						}
					} else {
						this.setValue(newVal);
					}
				} else {
					this.selectedValue = null;
				}
			}
		},
		selectedValue: function (val) {
			this.valueFormatted = this.formatDate(this.selectedValue);
			if (val != null) {
				if (val != this.$props.value) {
					this.$nextTick(() => {
						this.$emit('input', val);
					});
				}
			} else {
				this.$nextTick(() => {
					this.$emit('input', null);
				});
			}
		},
	},
	methods: {
		textFieldBlur() {
			this.selectedValue = this.parseDate(this.valueFormatted);
		},
		textFieldFocus() {
			this.$refs.dateField.$el.querySelector('input').select();
		},
		parseDate(date) {
			if (!date) return null;
			let moment = require('moment');
			date = moment(date, 'D.M.YYYY.');
			if (date.isValid()) {
				return date.format('YYYY-MM-DD');
			}
			return null;
		},
		formatDate(date) {
			if (!date) return null;
			const [year, month, day] = date.split('-');
			return `${parseInt(day)}.${parseInt(month)}.${year}.`;
		},
		setValue(newVal) {
			this.selectedValue = newVal;
			this.valueFormatted = this.formatDate(this.selectedValue);
		},
	},
	mounted() {
		this.setValue(this.$props.value);
	},
};
</script>

<style scoped>
.custom-cursor {
	cursor: default !important;
}
</style>
